import { Flex, Text } from '@chakra-ui/react';
import { FormFeedback, OutlineCard } from '@morressier/alembic';
import { useFormContext } from 'react-hook-form';
import { FieldLabel } from 'src/components/Field';
import { ISubmissionFormData } from 'src/contexts/FormContext';
import { RadioGroup } from 'src/components/RadioGroup';
import { FormFieldPreferenceImmediatePublication } from '@publishing-engine/domain/types/article';
import { get } from 'lodash';

const ImmediatePublication = ({
  config
}: {
  config: FormFieldPreferenceImmediatePublication;
}) => {
  const {
    formState: { errors },
    control
  } = useFormContext<ISubmissionFormData>();
  const {
    params: { validations, labels },
    caseDataFields: { main: field }
  } = config;
  const error = get(errors, field);

  return (
    <OutlineCard padding={8} borderless>
      <Flex flexDirection="column" gap={4}>
        <FieldLabel
          isRequired={validations.required}
          label={labels.main}
          subText={labels.subtitle}
        />

        <RadioGroup
          control={control}
          name={field}
          options={[
            {
              value: true,
              children: (
                <>
                  <Text fontWeight="semibold">
                    {labels.options['true']?.main}
                  </Text>
                  <Text>{labels.options['true']?.secondary}</Text>
                </>
              )
            },
            {
              value: false,
              children: (
                <>
                  <Text fontWeight="semibold">
                    {labels.options['false']?.main}
                  </Text>
                  <Text>{labels.options['false']?.secondary}</Text>
                </>
              )
            }
          ]}
        />

        {error ? (
          <FormFeedback variant="error">
            Indicate your preference for immediate publication before
            proceeding.
          </FormFeedback>
        ) : null}
      </Flex>
    </OutlineCard>
  );
};

export default ImmediatePublication;
